var React = require('react');

function FontSize (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"nonzero","d":"M319.84 76.08H202.21v327.04h-86.35V76.08H0V0h319.84v76.08zm84.35 223.21V103.81h-41.23c-4.46 0-8.07-3.61-8.07-8.07 0-2.4 1.05-4.56 2.72-6.04l69.94-86.23c3-3.25 8.08-3.45 11.34-.44l70.93 87.23c3.03 3.25 2.85 8.35-.41 11.37a7.992 7.992 0 0 1-5.48 2.16l-41.23.02v195.48h41.23c4.45 0 8.07 3.62 8.07 8.07 0 2.31-.97 4.39-2.53 5.86l-70.14 86.43a8.036 8.036 0 0 1-11.37.41c-23.89-23.88-47.75-62.24-70.89-87.22-3.03-3.25-2.85-8.35.41-11.37a7.992 7.992 0 0 1 5.48-2.16l41.23-.02z"}));
}

FontSize.defaultProps = {"shapeRendering":"geometricPrecision","textRendering":"geometricPrecision","imageRendering":"optimizeQuality","fillRule":"evenodd","clipRule":"evenodd","viewBox":"0 0 512 403.12"};

module.exports = FontSize;

FontSize.default = FontSize;
